var render = function render(_c,_vm){return _c('div',{staticClass:"app-loading-indicator"},[_c('svg',{attrs:{"width":_vm.props.size,"height":_vm.props.size}},[_c('use',{attrs:{"xlink:href":"img/spinner.svg#spinner"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }